import { render } from "./ProfileContainer.vue?vue&type=template&id=bd18d9ba&scoped=true"
import script from "./ProfileContainer.vue?vue&type=script&lang=js"
export * from "./ProfileContainer.vue?vue&type=script&lang=js"

import "./ProfileContainer.vue?vue&type=style&index=0&id=bd18d9ba&scoped=true&lang=css"

import exportComponent from "/home/salih/development/sayberdata-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bd18d9ba"]])

export default __exports__